import { CommonUtilsService } from "util/util";
import { IStorageAccessor } from "util/domain";
import {
	ActionService,
	LinkAuthExceptionFactory,
	EnvironmentService,
	HostBridgeService,
	HybridAuthService,
	WebAuthService
} from "phoenix/services";

/**
* @ngdoc service
* @name  phoenix.pxAuthService
*
* @description
* A service that handles user authentication and provides information
* about the current authenticated user
*
**/
export function AuthServiceFactory(
	$window:ng.IWindowService,
	$http: ng.IHttpService,
	$q: ng.IQService,
	$injector,
	$location:ng.ILocationService,
	utils:CommonUtilsService,
	settingsService,
	localStorageService:IStorageAccessor,
	sessionStorageService:IStorageAccessor,
	pxActionService:ActionService,
	pxEnvironmentService:EnvironmentService,
	pxHostBridgeService:HostBridgeService,
	pxLinkAuthExceptionFactory:LinkAuthExceptionFactory
) {
	if (pxEnvironmentService.isInShell) {
		return new HybridAuthService(
			$window,
			$http,
			$q,
			$injector,
			$location,
			settingsService,
			localStorageService,
			sessionStorageService,
			pxActionService,
			pxEnvironmentService,
			pxLinkAuthExceptionFactory,
			pxHostBridgeService
		);
	}
	else {
		return new WebAuthService(
			$window,
			$http,
			$q,
			$injector,
			$location,
			utils,
			settingsService,
			localStorageService,
			sessionStorageService,
			pxEnvironmentService,
			pxLinkAuthExceptionFactory
		);
	}
}

AuthServiceFactory.$inject = [
	'$window',
	'$http',
	'$q',
	'$injector',
	'$location',
	'utils',
	'settingsService',
	'localStorageService',
	'sessionStorageService',
	'pxActionService',
	'pxEnvironmentService',
	'pxHostBridgeService',
	'pxLinkAuthExceptionFactory'
];


// WEBPACK FOOTER //
// ./src/phoenix/services/auth/auth-service-factory.ts